import kebabCase from 'lodash/kebabCase'
import startCase from 'lodash/startCase'
import uniqueId from 'lodash/uniqueId'

import ChartEmpty from '../components/charts/ChartEmpty'
import Chart from '../views/Chart'

export default class ChartRoute {
  constructor ({ chart = ChartEmpty, name = null, title = null } = { }) {
    this.chart = chart
    this.name = name || kebabCase(title) || chart.name || uniqueId('route-')
    this.title = title || startCase(this.name)
  }

  get meta () {
    return {
      title: ({ config }) => {
        const projectName = config.get('project.name')
        return `${this.title} - ${projectName}`
      }
    }
  }

  get props () {
    return {
      default: route => {
        return ({
          socialMode: String(route.query.socialMode).toLowerCase() === 'true',
          noFooter: String(route.query.noFooter).toLowerCase() === 'true',
          chart: this.chart
        })
      }
    }
  }

  get component () {
    return Chart
  }

  get components () {
    return {
      default: this.component
    }
  }

  get id () {
    return kebabCase(this.name).toLowerCase()
  }

  get anchor () {
    return `#${this.id}`
  }

  get path () {
    return `/${this.id}`
  }

  get isEmpty () {
    return this.chart === ChartEmpty
  }

  static create (...args) {
    return new ChartRoute(...args)
  }
}
